import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon bi-chevron-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("section", null, [
      _createElementVNode("img", {
        src: require(`../assets/img/404/404.gif`),
        alt: "404",
        class: "img-fluid"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, [
        _hoisted_3,
        _createTextVNode(" Go Back! ")
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}